module.exports = __webpack_public_path__ + "static/media/fix_it.8c624ffb.png";